import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
})
export class PaginatorComponent {
  page:number = 0
  @Input() totalRecords!: number;
  @Input() set pageNumber (pageNo:number){
    this.page = pageNo * 20
  };
  @Output() pageChange = new EventEmitter();
  // first: number = 0;
  rows: number = 20;

  onPageChange(event: any) {
    window.scrollTo({ top: 0 });
    this.pageChange.emit(event.page);
  }
}
